<template>
  <v-navigation-drawer
    :value="true"
    app
    dark
    permanent
    :mini-variant="isTablet"
    :expand-on-hover="isTablet"
    class="navigation"
  >
    <v-list>
      <v-list-item two-line class="mb-0">
        <v-list-item-content>
          <v-list-item-title>Admin</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list-item-group
        v-model="menu"
        mandatory
        active-class="menu-active"
      >

        <v-list-item to="/admin/member">
          <v-icon small>fa-user</v-icon>
          <v-list-item-title>會員管理</v-list-item-title>
        </v-list-item>

        <v-list-group
          :value="false"
        >
          <template v-slot:activator>
            <v-icon small class="pl-1">fa-user-tie</v-icon>
            <v-list-item-title class="ml-1">主播管理</v-list-item-title>
          </template>

          <v-list-item
            to="/admin/seller"
            exact
            dense
          >
            <v-list-item-content class="ml-10">
              <v-list-item-title>主播列表</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            to="/admin/seller/product/statistic"
            exact
            dense
          >
            <v-list-item-content class="ml-10">
              <v-list-item-title>商品明細</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            to="/admin/seller/statistic"
            exact
            dense
          >
            <v-list-item-content class="ml-10">
              <v-list-item-title>銷售總表</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

        </v-list-group>

        <v-list-item to="/admin/wealth">
          <v-icon small>fa-users</v-icon>
          <v-list-item-title>經紀管理</v-list-item-title>
        </v-list-item>

        <v-list-item to="/admin/product">
          <v-icon small>fa-shopping-cart</v-icon>
          <v-list-item-title>商品管理</v-list-item-title>
        </v-list-item>

        <v-list-item to="/admin/order">
          <v-icon small>fa-book</v-icon>
          <v-list-item-title>原味訂單管理</v-list-item-title>
        </v-list-item>

        <v-list-item to="/admin/peach">
          <v-icon small>fa-percent</v-icon>
          <v-list-item-title>桃子匯率管理</v-list-item-title>
        </v-list-item>

        <v-list-item to="/admin/announcement">
          <v-icon small>fa-bullhorn</v-icon>
          <v-list-item-title>系統公告</v-list-item-title>
        </v-list-item>

        <v-list-item to="/admin/banner">
          <v-icon small>fa-image</v-icon>
          <v-list-item-title>banner上架</v-list-item-title>
        </v-list-item>

        <v-list-group
          :value="false"
        >
          <template v-slot:activator>
            <v-icon small class="pl-1">fa-comments</v-icon>
            <v-list-item-title class="ml-1">聊天管理</v-list-item-title>
          </template>

          <v-list-item
            to="/admin/chat/gift"
            exact
            dense
          >
            <v-list-item-content class="ml-10">
              <v-list-item-title>聊天室禮物</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            to="/admin/chat/keyword"
            exact
            dense
          >
            <v-list-item-content class="ml-10">
              <v-list-item-title>違規關鍵字</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            to="/admin/chat/record"
            exact
            dense
          >
            <v-list-item-content class="ml-10">
              <v-list-item-title>聊天記錄</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            to="/admin/chat/violation"
            exact
            dense
          >
            <v-list-item-content class="ml-10">
              <v-list-item-title>違規清單</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

        </v-list-group>

        <v-list-item to="/admin/audit">
          <v-icon small>fas fa-address-book</v-icon>
          <v-list-item-title>審核清單</v-list-item-title>
        </v-list-item>

        <v-list-item to="/admin/ban">
          <v-icon small>fa-user-slash</v-icon>
          <v-list-item-title>封鎖名單</v-list-item-title>
        </v-list-item>

        <v-list-item to="/admin/remittance">
          <v-icon small>fa-dollar-sign</v-icon>
          <v-list-item-title>提款申請</v-list-item-title>
        </v-list-item>

        <v-list-item to="/admin/tools">
          <v-icon small>fa-tools</v-icon>
          <v-list-item-title>常用工具</v-list-item-title>
        </v-list-item>

      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  data() {
    return {
      menu: 0,
      isTablet: window.innerWidth <= 1024
    }
  },
  mounted() {
    this.checkIsTablet()
  },
  methods: {
    checkIsTablet() {
      window.addEventListener('resize', () => {
        this.isTablet = window.innerWidth <= 1024
      })
    }
  }
}
</script>

<style lang="scss">
.navigation {
  background-color: $grey-3 !important;
  .menu-active:not(.no-active) {
    color: white !important;
  }
  .v-icon {
    width: 30px;
    margin-right: 12px;
  }
  .v-list-item__icon {
    i {
      font-size: 16px;
    }
  }
}
</style>